/* eslint-disable */

export const valueSchema = {
  type: 'object',
  properties: {
    value: {
      type: 'array',
      items: {
        type: 'object',
        properties: {
          key: {
            type: 'string',
            enum: [
              'PLANS_ARE_CREATED_BASED_ON_ISSUES_UNCOVERED_THROUGH_MONITORING_',
              'PLANS_INCLUDE_ROOT_CAUSE_ANALYSIS_RCA_',
              'PLANS_INCLUDE_GRIEVANCES_AND_SUGGESTIONS_RAISED_BY_WORKERS',
              'PLANS_ARE_COMPLETED_AND_THE_RELATED_ISSUES_RESOLVED',
              'WRITTEN_RECORDS_ARE_MAINTAINED',
              'OTHER',
            ],
          },
          isChecked: {
            type: 'boolean',
          },
          followUp: {
            type: ['object', 'null'],
            properties: {
              value: {
                type: 'string',
              },
            },
            required: ['value'],
          },
        },
        required: ['key', 'isChecked', 'followUp'],
      },
    },
  },
  required: ['value'],
}

export const validationSchema = {
  type: 'array',
  minItems: 1,
  items: {
    type: 'object',
    required: ['id', 'name'],
    additionalProperties: true,
    properties: {
      id: {type: 'string', minLength: 1},
      name: {type: 'string', minLength: 1},
    },
  },
}

export const answerSchema = {
  type: 'object',
  additionalProperties: false,
  properties: {
    does_the_fac_create_improvement_plans_based_on_social_and_labor: valueSchema,
  },
}
